import React from 'react';
import Base, { InfiniteScrollListProps } from './Base';

/**
 * H5 版无限滚动列表：空状态图片 200x200，文字 28px。
 */

import styles from './index.module.scss';

const InfiniteScrollListH5: React.FC<InfiniteScrollListProps> = (props) => {
    return (
        <Base
            {...props}
            className={styles.h5List}
        />
    );
};

export default InfiniteScrollListH5;
